import { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import ProductObj from "../../../../OBJRep/Product";
import ProductStyles from "../../../../OBJRep/ProductStyles";
import { isCartazFormat } from "../../../../services/Utils";
import EncarteProduct from "../../../sharable/EncarteProduct/EncarteProduct";
import {
  NAME_ABOVE_PRODUCT_LAYOUT,
  NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
  NAME_BENEATH_PRODUCT_LAYOUT,
  PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ROUGHLY_ROUNDED_PRICE_STYLE,
  TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
} from "../../CanvasViewer/EncarteConstants";
import WorkspaceContext from "../../WorkspaceContext";

const Container = styled.div`
  height: min-content
  overflow-y: auto;
  main {
    width: 100%;

    gap: 3.6rem;
    flex-direction: column;
  }

  h2 {
    margin-bottom: 2.4rem;
    text-transform: capitalize;
  }
`;

const LayoutWrapper = styled.div`
  height: 150px;
  width: 100%;
  border: 1px solid transparent;
  border-radius: 3px;
  padding: 1.2rem 0;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  &:hover {
    border: 1px solid #d97706;
  }

  ${({ selected }) => {
    return (
      selected == true &&
      css`
        background-color: #d97706;
        color: #fff;
      `
    );
  }}
`;

const LayoutContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
`;
export default function ProductLayout({ selectedProduct, updateProductStyle }) {
  const [currentLayout, setCurrentLayout] = useState(NAME_ABOVE_PRODUCT_LAYOUT);
  const demoProducts = getDemoProducts();

  const { styles, canvasScale } = useContext(WorkspaceContext);
  useEffect(() => {
    let layout = undefined;
    if (
      selectedProduct &&
      selectedProduct.styles &&
      selectedProduct.styles.productLayout
    )
      layout = selectedProduct.styles.productLayout;
    else layout = NAME_ABOVE_PRODUCT_LAYOUT;
    setCurrentLayout(layout);
  }, [selectedProduct, styles]);
  const handleLayoutChange = (e) => {
    const layoutWrapper = e.target.closest(".layout");
    if (!layoutWrapper) return;
    const layout = layoutWrapper.getAttribute("data-layout-id");
    setCurrentLayout(layout);
    updateProductStyle("productLayout", layout);
  };
  if (isCartazFormat(styles.format)) return null;
  return (
    <Container>
      <h2>Layout do produto</h2>
      {currentLayout && (
        <LayoutContainer className="flex" onClick={handleLayoutChange}>
          {demoProducts.map((product, index) => (
            <LayoutWrapper
              key={index}
              selected={
                currentLayout === undefined ||
                currentLayout === product.styles.productLayout
                  ? true
                  : false
              }
              className="layout"
              data-layout-id={product.styles.productLayout}
            >
              <EncarteProduct
                scale={0.5}
                styles={styles}
                product={product}
                canvasScale={canvasScale}
                index={0}
                isProductClickable={false}
                productsLength={1}
              />
            </LayoutWrapper>
          ))}
        </LayoutContainer>
      )}
    </Container>
  );
}

function getDemoProducts() {
  const baseStyles = ProductStyles();
  baseStyles.fontSize = "24";
  baseStyles.bgColor = "transparent";
  baseStyles.txtColor = "#fff";
  baseStyles.priceStyle = ROUGHLY_ROUNDED_PRICE_STYLE;

  const baseProduct = ProductObj(
    0,
    "Coca cola 2L",
    "6,49",
    "",
    "images/coca.png",
    "UND",
    baseStyles,
  );
  baseProduct.displayUrl = "images/coca.png";

  const layouts = [
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ];

  return layouts.map((layout, idx) => {
    const productCopy = { ...baseProduct };
    const stylesCopy = { ...baseStyles, productLayout: layout };
    productCopy.styles = stylesCopy;
    return productCopy;
  });
}
